
export enum UserType {
  USER = "user",
  ADMIN = "admin",
  RESEARCHER = "researcher",
  TESTER = "tester",
  LOAD_TESTER = "load_tester",
  GUEST = "guest",
  MANAGER = "manager",
}

export interface AuthModel {
  is_signed_in: boolean
}

interface UplodableFileExtensions {
  image_understanding: string[]
  video_understanding: string[]
}

interface UploadableFiles {
  image_understanding: number
  video_understanding: number
}

interface UploadableMaxFileSizeInMB { 
  image_understanding: number
  video_understanding: number
}

export interface ProjectContentSettingModel {
  attribution: boolean
  image_understanding: boolean
  video_understanding: boolean
  deep_thinking: boolean
}

export interface ProjectPromptSettingModel {
  deep_thinking: boolean
  speech_to_text: boolean
  transcription: boolean
  transcription_max_file_size: number
  transcription_max_files: number
  text_to_speech: boolean
  image_generation: boolean
  image_generation_triggering_terms: string
  image_understanding: boolean
  image_understanding_max_file_size: number
  image_understanding_max_files: number
  video_understanding: boolean
  video_understanding_max_file_size: number
  video_understanding_max_files: number
  image_search: boolean
  music_generation: boolean
  translate: boolean
  uploadable_file_extension: UplodableFileExtensions
}

export interface ProjectResponseSettingModel {
  reaction: boolean
  regenerate: boolean
  text_to_speech: boolean
  image_generation: boolean
  image_search: boolean
  translate: boolean
  music_generation: boolean
  diacritize: boolean
}

export interface EvaluationSetModel {
  id: string
  name: string
  model_ids: string[]
}
export interface ProjectModel {
  id?: string
  name?: string
  description?: string
  model_types?: string[]
  content_setting?: ProjectContentSettingModel
  prompt_setting?: ProjectPromptSettingModel
  response_setting?: ProjectResponseSettingModel
}

export interface UserModel {
  email?: string
  type?: UserType
  picture?: string
  settings: ProjectModel
  chat_id?: string
}